import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@/app/features/auth/services/auth.service';

export const authMatchGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  return auth.isAuthenticated(); // true => usa layout privado
};

// export const authMatchGuard: CanMatchFn = () => true;